import Axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/'


const crudeInstance = Axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },

});

function getBearerToken() {
  const Auth = JSON.parse(localStorage.getItem('auth'));
  if(Auth) {
    return Auth.accessToken;
  }
  return '';
}





export function loginUser(args) {
  return crudeInstance.post('user/auth/login', args);
}

export function registerUser(args) {
  return crudeInstance.post('user/auth/register', args);
}
export function registerProject(args) {
  Axios.defaults.headers.common.Authorization = `Bearer ${getBearerToken()}`;
  return crudeInstance.post('project', args);
}

export function suspendUser(args) {
  Axios.defaults.headers.common.Authorization = `Bearer ${getBearerToken()}`;
  return crudeInstance.put(`user/suspend/${args}`);
}

export function suspendProject(args) {
  Axios.defaults.headers.common.Authorization = `Bearer ${getBearerToken()}`;
  return crudeInstance.put(`project/suspend/${args}`);
}

export function registerCompany(args) {
  Axios.defaults.headers.common.Authorization = `Bearer ${getBearerToken()}`;
  return crudeInstance.post('company', args);
}

export function suspendCompany(args) {
  Axios.defaults.headers.common.Authorization = `Bearer ${getBearerToken()}`;
  return crudeInstance.put(`company/suspend/${args}`);
}

export function getAppCOnfigs() {
  return crudeInstance.get('configs');
}

export function getJobAudits(jobNumber) {
  Axios.defaults.headers.common.Authorization = `Bearer ${getBearerToken()}`;
  return crudeInstance.get(`/jobcard/audit/${jobNumber}`);
}

export function getProjects() {
  Axios.defaults.headers.common.Authorization = `Bearer ${getBearerToken()}`;
  return crudeInstance.get('project');
}

export function getCompanies() {
  Axios.defaults.headers.common.Authorization = `Bearer ${getBearerToken()}`;
  return crudeInstance.get('company');
}

export function createJobCard(args) {
  Axios.defaults.headers.common.Authorization = `Bearer ${getBearerToken()}`;
  return crudeInstance.post('jobcard/create', args);
}

export function getUsers() {
  Axios.defaults.headers.common.Authorization = `Bearer ${getBearerToken()}`;
  return crudeInstance.get('user');
}

export function getMeters() {
  Axios.defaults.headers.common.Authorization = `Bearer ${getBearerToken()}`;
  const res =  crudeInstance.get('meter');
  console.log(res);
  return res
  
}

export function registerMeter(args) {
  Axios.defaults.headers.common.Authorization = `Bearer ${getBearerToken()}`;
  return crudeInstance.post('meter', args);
}

export function getJobCards() {
  Axios.defaults.headers.common.Authorization = `Bearer ${getBearerToken()}`;
  return crudeInstance.get('jobcard');
}

export function viewJob(args) {
  Axios.defaults.headers.common.Authorization = `Bearer ${getBearerToken()}`;
  return crudeInstance.get(`jobcard/${args}`);
}

export function getWorkspaceJobCards() {
  Axios.defaults.headers.common.Authorization = `Bearer ${getBearerToken()}`;
  return crudeInstance.get('jobcard/workspace');
}

export function activateMeter(args) {
  Axios.defaults.headers.common.Authorization = `Bearer ${getBearerToken()}`;
  console.log("args.jobnumber: ", args.jobReference);
  console.log("args.tokens: ", args.tokens);
  return crudeInstance.put(`jobcard/meter-activation-token/${args.jobReference}`, args.tokens);
}

export function assignContractor(args) {
  Axios.defaults.headers.common.Authorization = `Bearer ${getBearerToken()}`;
  return crudeInstance.put(`/jobcard/assign-contractor/${args.job_reference}/${args.contactor_reference}`);
}

export function assignInspectorCompany(args) {
  Axios.defaults.headers.common.Authorization = `Bearer ${getBearerToken()}`;
  return crudeInstance.put(`/jobcard/assign-inspector-company/${args.job_reference}/${args.inspector_company_reference}`);
}

export function assignTechnician(args) {
  Axios.defaults.headers.common.Authorization = `Bearer ${getBearerToken()}`;
  return crudeInstance.put(`/jobcard/assign-technician/${args.job_reference}/${args.technician_reference}`);
}

export function managementDecision(args) {
  Axios.defaults.headers.common.Authorization = `Bearer ${getBearerToken()}`;
  return crudeInstance.put('jobcard/management-decision', args);
}

export function assignInspector(args) {
  const { job_reference , inspector_reference } = args
  Axios.defaults.headers.common.Authorization = `Bearer ${getBearerToken()}`;
  return crudeInstance.put(`jobcard/assign-inspector/${job_reference}/${inspector_reference}`);
}

export function qualityControl(args) {
  Axios.defaults.headers.common.Authorization = `Bearer ${getBearerToken()}`;
  return crudeInstance.put('jobcard/quality-control', args);
}

export function failedExecution(args) {
  Axios.defaults.headers.common.Authorization = `Bearer ${getBearerToken()}`;
  return crudeInstance.put('jobcard/meter-activation-token', args);
}

